// extracted by mini-css-extract-plugin
export default {"scrollTable":"ConversionManagerTable_scrollTable__zK4wD"};